/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name CaretUp
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQuMjIgMTYuMzFhLjc1Ljc1IDAgMDEwLTEuMDZMMTEuNDcgOGwuNTMtLjUzLjUzLjUzIDcuMjUgNy4yNWEuNzUuNzUgMCAwMS0xLjA2IDEuMDZMMTIgOS41OWwtNi43MiA2LjcyYS43NS43NSAwIDAxLTEuMDYgMCIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+) - https://fondue-components.frontify.com/?path=/story/icons_icons--default&args=iconName:caret-up
 * @see https://fondue-components.frontify.com/?path=/story/icons_icons--default - Documentation
 */
export const IconCaretUp = createFondueIcon('CaretUp', [["path",{"fill":"currentColor","fill-rule":"evenodd","d":"M4.22 16.31a.75.75 0 010-1.06L11.47 8l.53-.53.53.53 7.25 7.25a.75.75 0 01-1.06 1.06L12 9.59l-6.72 6.72a.75.75 0 01-1.06 0","clip-rule":"evenodd"}]]);
